import type { VoidFunctionComponent } from 'react';

import { prettyMDY } from '../../../../shared/utils/dates';
import Tooltip from '../Tooltip';

import FromNow from './FromNow';
import type { FromNowProps } from './FromNow';

type Props = Omit<FromNowProps, 'date'> & { date: string | null | undefined };

/**
 * Wraps a FromNow, but provides a tooltip which will display the full
 * date, formatted via prettyMDY.
 *
 * @param {Props} props - FromNow props
 * @param {string} props.date - A date string.
 * @param {number} [props.updateInterval] - If you wanted to customize how often this is updated.
 */
const FromNowWithTooltip: VoidFunctionComponent<Props> = ({ date }) => {
  //  This is mostly just for TS
  if (!date) {
    return null;
  }
  return (
    <Tooltip id={`from-now-tooltip-${date}`} tooltip={prettyMDY(date)}>
      <span className="inline-block">
        <FromNow date={date} />
      </span>
    </Tooltip>
  );
};

export default FromNowWithTooltip;
